var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-search",class:[_vm.deviceType]},[_c('div',{staticClass:"search-header"},[_c('router-link',{staticClass:"search-title-link",attrs:{"to":"/names"}},[_c('div',{staticClass:"search-title"},[_vm._v("Search by Filter")])])],1),_c('div',{staticClass:"search-content"},[_c('SearchFilter')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }